





































import Vue from 'vue';
import VToolbar from 'vuetify/lib/components/VToolbar/VToolbar';
import themes from '../../styles/themes';
import SToolbarLight from '../SToolbarLight/SToolbarLight.vue';

export default Vue.extend({
  name: 'SToolbar',
  components: {
    SToolbarLight,
    VToolbar: VToolbar as any, // Stops typescript complaining about component
  },
  props: {
    /**
     * If true the toolbar will be shorter
     */
    dense: {
      type: Boolean,
      required: false,
    },

    /**
     * The Vuetify Color to make the toolbar
     */
    color: {
      type: String,
      required: false,
    },

    /**
     * Used to work out what color any text should be. Probably wanna pass in the same as the
     * color prop
     */
    theme: {
      type: String,
      default: 'primary',
    },

    /**
     * If the component should use the v-toolbar replacement, which uses up
     * less browser resources (each v-toolbar adds a window scroll listener)
     */
    useLightToolbar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dark(): boolean {
      return themes[this.theme]?.darkHeader;
    },

    component(): string {
      return this.useLightToolbar ? 'SToolbarLight' : 'v-toolbar';
    },

    className(): any {
      return this.useLightToolbar
        ? {}
        : { 'v-toolbar__content--small': this.dense };
    },
  },
});
